import {useContext} from 'react';
import {ScriptTagData, HeadTagSetterContext} from './HeadTagSetterContext';

/**
 * Injects a script into the head tag of page, works both in SSR and browser modes
 */
export function useScriptInjector(script: ScriptTagData) {
	const context = useContext(HeadTagSetterContext);
	if (!context) {
		throw new Error('useScriptInjector error: context is not provided');
	}

	context.addScript(script);

	return () => {
		context.removeScript(script);
	};
}

useScriptInjector.displayName = 'useScriptInjector';
